import adminStyles from "../../styles/components/AdminDetailModals.module.css";
import contactStyles from "../../styles/components/ContactDetailModal.module.css";
import { useOverlayClose } from "../../hooks/useOverlayClose";

const styles = { ...adminStyles, ...contactStyles };

export function ConfirmDeleteModal({
  name,
  onCancel,
  onConfirm,
  deleting,
  title = "¿Eliminar contacto?",
  description,
}) {
  const overlayCloseProps = useOverlayClose(onCancel);
  return (
    <div className={styles.centerOverlay} {...overlayCloseProps}>
      <div className={styles.confirmModal} onClick={(event) => event.stopPropagation()}>
        <div className={styles.confirmBody}>
          <div className={styles.confirmTitle}>{title}</div>
          <div className={styles.confirmDesc}>
            {description ?? (
              <>
                Esta acción no se puede deshacer. El contacto{" "}
                <strong>{name}</strong> será eliminado permanentemente.
              </>
            )}
          </div>
        </div>
        <div className={styles.confirmActions}>
          <button className={styles.confirmCancelBtn} onClick={onCancel}>
            Cancelar
          </button>
          <button
            className={styles.confirmDeleteBtn}
            onClick={onConfirm}
            disabled={deleting}
          >
            {deleting ? "Eliminando..." : "Eliminar"}
          </button>
        </div>
      </div>
    </div>
  );
}

export function ConfirmLoseValidationModal({ actionKind, emailAddress, onCancel, onConfirm }) {
  const isRemoval = actionKind === "remove";
  const overlayCloseProps = useOverlayClose(onCancel);
  return (
    <div className={styles.centerOverlay} {...overlayCloseProps}>
      <div className={styles.confirmModal} onClick={(event) => event.stopPropagation()}>
        <div className={styles.confirmBody}>
          <div className={styles.confirmTitle}>
            {isRemoval ? "¿Eliminar email validado?" : "¿Modificar email validado?"}
          </div>
          <div className={styles.confirmDesc}>
            Si {isRemoval ? "eliminás" : "modificás"} <strong>{emailAddress}</strong>{" "}
            se pierde su estado de validación y los créditos consumidos no se
            reembolsan.
          </div>
        </div>
        <div className={styles.confirmActions}>
          <button className={styles.confirmCancelBtn} onClick={onCancel}>
            No, conservar
          </button>
          <button className={styles.confirmDeleteBtn} onClick={onConfirm}>
            Sí, continuar
          </button>
        </div>
      </div>
    </div>
  );
}
